import React from 'react'
import { Card, Button } from 'react-bootstrap'
import Rating from './Rating'
import { Link } from 'react-router-dom'
import { formatCurrency, computePromoPercent } from '../utils/currency'

function Product({product}) {
  const promo = product.promo_percent || computePromoPercent(product.price, product.compareAtPrice)
  const priceText = formatCurrency(product.price, product.currency)
  const compareText = product.compareAtPrice ? formatCurrency(product.compareAtPrice, product.currency) : null
  return (
    <Card className="ws-card">
      <div style={{position:'relative'}}>
        <Link to={`/product/${product._id}`}>
          <Card.Img src={product.image} />
        </Link>
        {promo > 0 && <div className="ws-badge">-{promo}%</div>}
        {product.isFeatured && <div className="ws-badge" style={{right:12, left:'auto'}}>FEATURED</div>}
      </div>
      <Card.Body>
        <div className="ws-kicker">{product.category || 'WIG'}</div>
        <Link to={`/product/${product._id}`}>
          <Card.Title as="div">
            <strong>{product.name}</strong>
          </Card.Title>
        </Link>
        <div className="mb-2">
          <Rating value={product.rating} text={`${product.numReviews} reviews`} color={'#f8e825'} />
        </div>
        <div className="ws-price-row">
          <div className="ws-price">
            {priceText}{' '}
            {compareText && (
              <span className="text-muted" style={{textDecoration:'line-through', fontWeight:400, marginLeft:8}}>
                {compareText}
              </span>
            )}
          </div>
          <Link to={`/cart/${product._id}?qty=1`} className="ws-cart-btn">
            <i className="fas fa-shopping-bag"></i>
          </Link>
        </div>
      </Card.Body>
    </Card>
  )
}

export default Product